import {
  CollaborationV1ExternalDocumentSourceType,
  CollaborationV1ProviderDocumentPage,
} from '@spotify/confidence-graphql';

const GOOGLE_SLIDES_MIME_TYPE = 'application/vnd.google-apps.presentation';

export type SelectableProviderDocumentPage =
  CollaborationV1ProviderDocumentPage & {
    id: string;
  };

export const hasSelectableProviderDocumentFields = (
  page: CollaborationV1ProviderDocumentPage,
): page is SelectableProviderDocumentPage => Boolean(page.id);

export const providerDocumentSourceType = (
  dialogSourceType: CollaborationV1ExternalDocumentSourceType,
  page: CollaborationV1ProviderDocumentPage,
): CollaborationV1ExternalDocumentSourceType =>
  dialogSourceType === CollaborationV1ExternalDocumentSourceType.GoogleDocs &&
  page.mimeType === GOOGLE_SLIDES_MIME_TYPE
    ? CollaborationV1ExternalDocumentSourceType.GoogleSlides
    : dialogSourceType;

export const requireProviderDocumentSource = (
  page: CollaborationV1ProviderDocumentPage,
): { sourceId: string } => {
  if (!page.id) {
    throw new Error('Selected document is missing an id');
  }

  return {
    sourceId: page.id,
  };
};
